import { useNavigate } from 'react-router-dom';
import { MdFitnessCenter, MdDarkMode, MdLightMode, MdLogout } from 'react-icons/md';
import { adminNavItems } from '../../config/adminNav';
import SidebarNav from '../shared/SidebarNav';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { useGymSettings } from '../../context/GymSettingsContext';
import '../owner/Sidebar.css';

function AdminSidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const { logout } = useAuth();
  const { settings, gym } = useGymSettings();
  const logo = settings?.logoPreview;
  const gymName = gym?.name?.trim() || 'Gym CRM';

  const handleLogout = async () => {
    onClose?.();
    try {
      await logout();
    } catch {
      // still redirect on sign-out errors
    }
    navigate('/');
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} aria-hidden="true" />}
      <aside className={`owner-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-brand">
          <div className={`sidebar-brand-icon${logo ? ' sidebar-brand-icon-logo' : ''}`}>
            {logo ? (
              <img src={logo} alt="" className="sidebar-brand-logo" />
            ) : (
              <MdFitnessCenter />
            )}
          </div>
          <div className="sidebar-brand-text">
            <span className="sidebar-brand-title">{gymName}</span>
            <span className="sidebar-brand-subtitle">Gym Admin</span>
          </div>
          <button
            type="button"
            className="sidebar-theme-toggle"
            onClick={toggleTheme}
            aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
            title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
          >
            {theme === 'dark' ? <MdLightMode /> : <MdDarkMode />}
          </button>
        </div>

        <SidebarNav items={adminNavItems} onClose={onClose} />

        <div className="sidebar-footer">
          <button type="button" className="sidebar-logout-btn" onClick={handleLogout}>
            <MdLogout className="sidebar-link-icon" />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}

export default AdminSidebar;
